<template>
    <div class="flex rounded-2xl overflow-hidden shadow-lg">
        <slot />
    </div>
</template>
<script setup>
</script>